/* eslint-disable quotes */
import React, { useState, useEffect, useRef } from 'react'
import { ServicesWrapper } from '../components/services/styles'
import {
  fetchServicesForMarket,
  loadMarkets,
} from '../services/GraphQlClientService'
import LoadingStep from '../components/book/steps/components/LoadingStep'
import { useMarketContext } from '../components/MarketContext'
import Head from 'next/head'
import Hero from '../components/Hero'
import HeroImage from '../../public/services-banner.jpg'
import MarketServiceSelector from '../components/MarketServiceSelector/MarketServiceSelector'
import ServiceCardList from '../components/ServiceCardList'

// ensure page has access to marketServices immediately
export const getServerSideProps = async () => {
  const [nyMarket] = await loadMarkets()
  const marketServices = await fetchServicesForMarket(nyMarket.id)

  return {
    props: {
      marketServices,
    },
  }
}

const Services = ({ marketServices }) => {
  const { markets, selectedMarket, setSelectedMarket } = useMarketContext()
  const [services, setServices] = useState(marketServices)

  // service type bar selected state
  const [selectedTab, setSelectedTab] = useState('')

  // observer logic for detecting section scroll into view
  const observer = useRef(null)
  const handleIntersection = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        setSelectedTab(entry.target.id)
      }
    })
  }

  useEffect(() => {
    if ('IntersectionObserver' in window) {
      observer.current = new IntersectionObserver(handleIntersection, {
        root: null,
        rootMargin: '-50%',
      })

      const container = document.querySelector('.content-wrapper')
      Array.from(container.children).forEach((child) =>
        observer.current.observe(child)
      )

      return () => {
        observer.current.disconnect()
      }
    }
  }, [])

  useEffect(() => {
    if (selectedMarket) {
      fetchServicesForMarket(selectedMarket.id).then((s) => {
        setServices(s)
      })
    }

    setSelectedTab('')
  }, [selectedMarket])

  return (
    <>
      <Head>
        <title>Hair, Makeup & Nail Services | GLAMSQUAD</title>
        <meta name="description" content="Book in-home hair, makeup, and nail services from GLAMSQUAD — blowouts, makeup, manicures, pedicures, silk press, and more, delivered to your door." />
        <link rel="canonical" href="https://glamsquad.com/services" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Hair, Makeup & Nail Services | GLAMSQUAD" />
        <meta property="og:description" content="Browse GLAMSQUAD's full menu of in-home beauty services — blowouts, makeup, manicures, pedicures, updos, silk press, and more." />
        <meta property="og:url" content="https://glamsquad.com/services" />
      </Head>

      <ServicesWrapper>
        <div className="services-banner">
          <Hero
            fullWidth
            header="HAIR, MAKEUP + MORE"
            subheader={`You're made for more than hours in front of the mirror. Take your time back with glam on call.`}
            image={HeroImage}
          />
        </div>
        <MarketServiceSelector
          markets={markets}
          selectedMarket={selectedMarket}
          setSelectedMarket={setSelectedMarket}
          services={services}
          selectedTab={selectedTab}
        />
        <ServiceCardList services={services} selectedMarket={selectedMarket} />
      </ServicesWrapper>

      {!markets ||
        (!services && (
          <div
            style={{
              height: 'calc(100vh - 400px)',
              width: '100%',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <LoadingStep />
          </div>
        ))}
    </>
  )
}

export default Services
